import React from "react";
import * as constants from "Constants";
import { Button, Modal, Form } from "react-bootstrap";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import log from "loglevel";
import httpService from "services/httpService";



const TaBuddy = ({selectedSubmissions,criteriaState, setCriteriaState, newReqModal, handleModalClose, criteriasWithAiGrading, listOfAllSubmissions, isSelectAllChecked, program_id, aiGradingList, setAiGradingList}) => {
      const handleAddSubmissionPlag = () => {
        displayGlobalMessage("Add Hogya handle"+criteriaState, "sucess");
      };
    
      const handleRemoveSubmissionPlag = (pid) => {
        displayGlobalMessage("Remove Hogya handle", "sucess");
      };
    
      const handleInferenceRequest = async () => {
        let submission_list = [];
        let form_data = new FormData();

        if (selectedSubmissions.length == 0 || isSelectAllChecked) {
          form_data.append("all_submissions", "true");
        } else {
          submission_list = selectedSubmissions
            .map((submission) => submission.id) // Map to ids
            .filter((id) => id !== undefined && id !== null); // Filter out undefined and null ids
          form_data.append("submissions", submission_list);
        }

        
        
      
        const url =
          constants.base_url +
          "/evalpro/rubric/predict/" +
          program_id +
          "/" +
          criteriaState;
      
        try {
          const response = await httpService.put(url, form_data);
          log.log("Put request successful for prediction");
          const msg = response?.data?.msg;
          displayGlobalMessage(msg);
          setAiGradingList([...aiGradingList, submission_list]);
        } catch (error) {
          log.error(error);
          const errMsg = error?.response?.data?.msg || "An error occurred";
          displayGlobalMessage(errMsg, "error");
        }
      };
    
    return (
      <>
        <Modal show={newReqModal} onHide={handleModalClose} backdrop="static">
          <Modal.Header
            style={{
              backgroundColor: "#FFFFFF",
              paddingLeft: "30px",
              paddingRight: "30px",
            }}
            closeButton
          >
            <Modal.Title style={{ fontWeight: "500", fontSize: "32" }}>
              TA Buddy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              backgroundColor: "#FFFFFF",
              paddingLeft: "30px",
              paddingRight: "30px",
              paddingTop: "0px",
            }}
          >
            <Form style={{ marginTop: "20px" }}> 
              <Form.Group controlId="formPlagChecker">
                <Form.Label
                  style={{
                    fontWeight: "500",
                    fontSize: "16",
                    marginBottom: "4px",
                  }}
                >
                  Select Criterion
                </Form.Label>
                <Form.Control
                  as="select"
                  onChange={(e) => {
                    setCriteriaState(e.target.value);
                  }}
                  style={{
                    fontWeight: "400",
                    color: "#666666",
                    fontSize: "16",
                  }}
                >
                {criteriasWithAiGrading.map((criteria, index) => (
                    <option value={criteria} key={criteria}>
                    {criteria}
                    </option>
                ))}
                </Form.Control>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer
            style={{
              backgroundColor: "#FFFFFF",
              paddingLeft: "30px",
              paddingRight: "30px",
            }}
          >
            <Button
              variant="secondary"
              onClick={handleModalClose}
              style={{ fontWeight: "400", fontSize: "16" }}
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={handleInferenceRequest}
              style={{ fontWeight: "400", fontSize: "16" }}
            >
              Submit AI Grading Request
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

export default TaBuddy;